export default __webpack_public_path__ + "static/media/FOTO2.4eb6dbcb.jpg";